import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import GetIcon from "@/components/font-awesome-icon";

const UIButton = ({
  title = "",
  icon,
  loading = false,
  variant = "contained",
  children,
  size = "small",
  sx = {},
  disabled = false,
  fullWidth = false,
  ...rest
}) => {
  const content =
    children ||
    (icon && typeof title === "string" ? (
      <GetIcon title={title} icon={icon} />
    ) : (
      title
    ));

  return (
    <Button
      fullWidth={fullWidth}
      variant={variant}
      disabled={disabled || loading}
      sx={{
        minWidth: "10px",
        minHeight: 36,
        boxSizing: "border-box",
        textTransform: "none",
        fontSize: "1rem",
        fontWeight: "normal",
        lineHeight: 1.25,
        ...sx,
      }}
      size={size}
      {...rest}
    >
      {content}
      {loading && (
        <CircularProgress
          sx={{ ml: 1, color: "var(--palette-secondary_button_text)" }}
          size={18}
        />
      )}
    </Button>
  );
};

export default UIButton;
